var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('the-menu'),_c('router-view'),_c('the-footer'),_c('cookies')],1)}
var staticRenderFns = []

export { render, staticRenderFns }